import SiteButton_ShinyButtonIISkinComponent from '../components/SiteButton/viewer/skinComps/BaseButton/ShinyButtonIISkin.skin';
import SiteButton_ShinyButtonIISkinController from '../components/SiteButton/viewer/SiteButton.controller';


const SiteButton_ShinyButtonIISkin = {
  component: SiteButton_ShinyButtonIISkinComponent,
  controller: SiteButton_ShinyButtonIISkinController
};


export const components = {
  ['SiteButton_ShinyButtonIISkin']: SiteButton_ShinyButtonIISkin
};

